// extracted by mini-css-extract-plugin
export default {"form-wrapper":"styles_form-wrapper__rWrkV","logo":"styles_logo__XZshW","form":"styles_form__BSYq2","form__btns":"styles_form__btns__Darnh"};